class ProductCarousel extends HTMLElement {
    constructor() {
        super();
        this.swiperThumbsEl = this.querySelector('.swiper-thumbs');
        this.swiperEl = this.querySelector('.swiper-product-carousel');
        this.nextEl = this.querySelector('.swiper-button-next');
        this.prevEl = this.querySelector('.swiper-button-prev');
        this.swiper = null;
        this.swiperThumbs = null;
    }

    connectedCallback() {
        this.swiperBuild();
    }

    swiperBuild() {
      let thumbs = null;

      if (this.swiperThumbsEl) {
        this.swiperThumbs = new Swiper(this.swiperThumbsEl, {
          spaceBetween: 10,
          slidesPerView: 6,
          initialSlide: 0,
            loop: false,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slideToClickedSlide: true,
        });

        thumbs = {
          thumbs: {
            swiper: this.swiperThumbs,
          },
        }


      }
      this.swiper = new Swiper(this.swiperEl, {
        speed: 400,
        spaceBetween: 100,
        initialSlide: 0,
        ...thumbs,
        navigation: {
              nextEl: this.nextEl,
              prevEl: this.prevEl,
          },
      });
      console.log('swiper initialized', this.swiper);
    }

}



customElements.define('product-carousel', ProductCarousel);